import React from "react";
import { Star, Users, MapPin, ShieldCheck } from "lucide-react";
import { useLang } from "@/lib/lang";

/**
 * Trust bar showing headline stats: Google rating, happy clients, drivers, fleet.
 */
export default function TrustBar() {
  const { t } = useLang();
  return (
    <div className="dt-trust" data-testid="trust-bar">
      <div className="dt-trust__row">
        <div className="dt-trust__item"><Star size={13} fill="currentColor" /> {t("landing_trust_google")}</div>
        <div className="dt-trust__item"><Users size={13} /> {t("landing_trust_clients")}</div>
        <div className="dt-trust__item"><MapPin size={13} /> {t("landing_trust_drivers")}</div>
        <div className="dt-trust__item"><ShieldCheck size={13} /> {t("landing_trust_fleet")}</div>
      </div>
    </div>
  );
}
